module.exports = "/dist/da732a679fdbe965d87ffbcee6ab3bd7.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-200.eot
// module id = 8
// module chunks = 0